export const PERMISSIONS = {
    SYNC_VIEW: {
        code: 'sync:view',
        scope: 'sync',
        description: 'Xem danh sách đồng bộ',
    },
    SYNC_EDIT: {
        code: 'sync:edit',
        scope: 'sync',
        description: 'Thực hiện đồng bộ',
    },
    LEARNER_VIEW: {
        code: 'learner:view',
        scope: 'learner',
        description: 'Xem danh sách học viên',
    },
    LEARNER_EDIT: {
        code: 'learner:edit',
        scope: 'learner',
        description: 'Sửa thông tin học viên',
    },
    LEARNER_EVENT_VIEW: {
        code: 'learner-event:view',
        scope: 'learner-event',
        description: 'Xem lịch sử học viên',
    },
    TEST_VIEW: {
        code: 'test:view',
        scope: 'test',
        description: 'Xem mã đề thi',
    },
    COURSE_VIEW: {
        code: 'course:view',
        scope: 'course',
        description: 'Xem danh sách khóa học',
    },
    COURSE_EDIT: {
        code: 'course:edit',
        scope: 'course',
        description: 'Sửa thông tin khóa học',
    },
    CONTACT_VIEW: {
        code: 'contact:view',
        scope: 'contact',
        description: 'Xem danh sách liên hệ',
    },
    CONTACT_EDIT: {
        code: 'contact:edit',
        scope: 'contact',
        description: 'Sửa thông tin liên hệ',
    },
    RELATIVE_VIEW: {
        code: 'relative:view',
        scope: 'relative',
        description: 'Xem danh sách người liên hệ',
    },
    RELATIVE_EDIT: {
        code: 'relative:edit',
        scope: 'relative',
        description: 'Sửa thông tin người liên hệ',
    },
    EMPLOYEE_VIEW: {
        code: 'employee:view',
        scope: 'employee',
        description: 'Sửa thông tin nhân viên',
    },
    EMPLOYEE_UPDATE: {
        code: 'employee:update',
        scope: 'employee',
        description: 'Cập nhật thông tin nhân viên',
    },
    EMPLOYEE_EDIT: {
        code: 'employee:edit',
        scope: 'employee',
        description: 'Sửa thông tin nhân viên',
    },
    ROLE_VIEW: {
        code: 'role:view',
        scope: 'role',
        description: 'Xem thông tin phân quyền',
    },
    ROLE_EDIT: {
        code: 'role:edit',
        scope: 'role',
        description: 'Sửa thông tin phân quyền',
    },
    SHIFT_SETTING_VIEW: {
        code: 'shiftSetting:view',
        scope: 'shiftSetting',
        description: 'Xem thông tin cấu hình ca trực',
    },
    SHIFT_SETTING_EDIT: {
        code: 'shiftSetting:edit',
        scope: 'shiftSetting',
        description: 'Sửa thông tin cấu hình ca trực',
    },
    DEPARTMENT_VIEW: {
        code: 'department:view',
        scope: 'department',
        description: 'Xem thông tin phòng ban',
    },
    DEPARTMENT_EDIT: {
        code: 'department:edit',
        scope: 'department',
        description: 'Sửa thông tin phòng ban',
    },
    CLUSTER_VIEW: {
        code: 'cluster:view',
        scope: 'cluster',
        description: 'Xem thông tin cụm',
    },
    CLUSTER_EDIT: {
        code: 'cluster:edit',
        scope: 'cluster',
        description: 'Sửa thông tin cụm',
    },
    POSITION_VIEW: {
        code: 'position:view',
        scope: 'position',
        description: 'Xem thông tin vị trí công việc',
    },
    POSITION_EDIT: {
        code: 'position:edit',
        scope: 'position',
        description: 'Sửa thông tin vị trí công việc',
    },
    PROBATION_VIEW: {
        code: 'probation:view',
        scope: 'probation',
        description: 'Xem thông tin thử việc',
    },
    PROBATION_EDIT: {
        code: 'probation:edit',
        scope: 'probation',
        description: 'Sửa thông tin thử việc',
    },
    CENTER_VIEW: {
        code: 'center:view',
        scope: 'center',
        description: 'Xem danh sách trung tâm',
    },
    CENTER_EDIT: {
        code: 'center:edit',
        scope: 'center',
        description: 'Sửa thông tin trung tâm',
    },
    ROOM_VIEW: {
        code: 'room:view',
        scope: 'room',
        description: 'Xem danh sách phòng',
    },
    ROOM_EDIT: {
        code: 'room:edit',
        scope: 'room',
        description: 'Sửa thông tin phòng',
    },
    ROOM_STATUS_VIEW: {
        code: 'room-status-history:view',
        scope: 'room',
        description: 'Xem danh sách lịch sử trạng thái phòng',
    },
    ROOM_STATUS_CREATE: {
        code: 'room-status-history:create',
        scope: 'room',
        description: 'Tạo thông tin lịch sử trạng thái phòng',
    },
    ROOM_STATUS_UPDATE: {
        code: 'room-status-history:update',
        scope: 'room',
        description: 'Sửa thông tin lịch sử trạng thái phòng',
    },
    ROOM_EVENT_VIEW: {
        code: 'room-event:view',
        scope: 'room-event',
        description: 'Xem danh sách đặt phòng',
    },
    ROOM_EVENT_EDIT: {
        code: 'room-event:edit',
        scope: 'room-event',
        description: 'Sửa thông tin đặt phòng',
    },
    TEACHER_VIEW: {
        code: 'teacher:view',
        scope: 'teacher',
        description: 'Xem thông tin giáo viên',
    },
    TEACHER_EDIT: {
        code: 'teacher:edit',
        scope: 'teacher',
        description: 'Sửa thông tin giáo viên',
    },
    EC_VIEW: {
        code: 'ec:view',
        scope: 'ec',
        description: 'Xem thông tin EC',
    },
    EC_EDIT: {
        code: 'ec:edit',
        scope: 'ec',
        description: 'Sửa thông tin EC',
    },
    TA_VIEW: {
        code: 'ta:view',
        scope: 'ta',
        description: 'Xem thông tin trợ giảng',
    },
    TA_EDIT: {
        code: 'ta:edit',
        scope: 'ta',
        description: 'Sửa thông tin trợ giảng',
    },
    TA_AVAIL_SELF_VIEW: {
        code: 'ta-avail-self:view',
        scope: 'ta',
        description: 'Xem thông tin trợ giảng của mình',
    },
    TA_AVAIL_SELF_EDIT: {
        code: 'ta-avail-self:edit',
        scope: 'ta',
        description: 'Sửa thông tin trợ giảng của mình',
    },
    TA_AVAIL_VIEW: {
        code: 'ta-avail:view',
        scope: 'ta',
        description: 'Xem thông tin trợ giảng',
    },
    TA_AVAIL_EDIT: {
        code: 'ta-avail:edit',
        scope: 'ta',
        description: 'Sửa thông tin trợ giảng',
    },
    COURSE_LEVEL_VIEW: {
        code: 'course-level:view',
        scope: 'course-level',
        description: 'Xem thông tin level',
    },
    COURSE_LEVEL_EDIT: {
        code: 'course-level:edit',
        scope: 'course-level',
        description: 'Sửa thông tin level',
    },
    TA_SHIFT_TIME_VIEW: {
        code: 'taShiftTime:view',
        scope: 'taShiftTime',
        description: 'Xem thông tin lịch trực trợ giảng',
    },
    TA_SHIFT_TIME_EDIT: {
        code: 'taShiftTime:edit',
        scope: 'taShiftTime',
        description: 'Sửa thông tin lịch trực trợ giảng',
    },
    TA_SHIFT_TIME_SELF_VIEW: {
        code: 'ta-shift-time-self:view',
        scope: 'ta',
        description: 'Xem thông tin lịch trực của mình',
    },
    SCHEDULE_LOCK_EDIT: {
        code: 'schedule-lock:edit',
        scope: 'schedule-lock',
        description: 'Sửa thông tin khóa lịch',
    },
    ADDRESS_ITEM_EDIT: {
        code: 'address-item:edit',
        scope: 'address-item',
        description: 'Sửa cấu hình địa chỉ',
    },
    HOST_ACC_VIEW: {
        code: 'host-acc:view',
        scope: 'host-acc',
        description: 'Xem thông tin host acc',
    },
    HOST_ACC_EDIT: {
        code: 'host-acc:edit',
        scope: 'host-acc',
        description: 'Sửa thông tin host acc',
    },
    ENROLMENT_VIEW: {
        code: 'enrolment:view',
        scope: 'enrolment',
        description: 'Xem danh sách yêu cầu xếp lớp',
    },
    ENROLMENT_EDIT: {
        code: 'enrolment:edit',
        scope: 'enrolment',
        description: 'Sửa thông tin yêu cầu xếp lớp',
    },
    ENROLMENT_TASK_VIEW: {
        code: 'enrolmentTask:view',
        scope: 'enrolmentTask',
        description: 'Xem danh sách task yêu cầu xếp lớp',
    },
    ENROLMENT_TASK_EDIT: {
        code: 'enrolmentTask:edit',
        scope: 'enrolmentTask',
        description: 'Sửa thông tin task yêu cầu xếp lớp',
    },
    FILTER_VIEW_SHARED_MANAGE: {
        code: 'filter-view-shared:manage',
        scope: 'filter-view',
        description: 'Quản lý bộ lọc chia sẻ',
    },
};